import React from "react";
import { Link, useLocation } from "react-router-dom";
import { img, navLinks, socialLinks } from "../../App/Landing/landingContent";
import Reveal from "./Reveal";

const base = process.env.REACT_APP_PublicPath;

const socialIcons: Record<string, JSX.Element> = {
  Facebook: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M14 8V6.500c0-.7.200-1 1.200-1H17V2h-2.700C11.500 2 10 3.600 10 6v2H8v3.500h2V22h4v-10.500h2.800L17 8z" /></svg>,
  Instagram: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.500" cy="6.500" r="1" fill="currentColor" /></svg>,
  YouTube: <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M21.600 7.200a2.500 2.500 0 00-1.800-1.800C18.200 5 12 5 12 5s-6.200 0-7.800.4A2.500 2.500 0 002.400 7.200C2 8.800 2 12 2 12s0 3.200.4 4.800a2.500 2.500 0 001.800 1.800C5.800 19 12 19 12 19s6.200 0 7.800-.4a2.500 2.500 0 001.800-1.800c.4-1.600.4-4.800.4-4.800s0-3.200-.4-4.800zM10 15V9l5.200 3z" /></svg>,
};

export default function LandingFooter() {
  const { pathname } = useLocation();
  const onLanding = pathname === base + "/";
  // Section anchors only resolve on the landing page itself
  const sectionHref = (hash: string) => (onLanding ? hash : base + "/" + hash);

  return (
    <footer className="font-jakarta bg-navy text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 grid gap-8 md:grid-cols-[1.2fr_2fr_auto] items-start">
        <Reveal delay={0}>
          <a href={onLanding ? "#top" : base + "/"} className="inline-block py-2" aria-label="BudgetPrintPros home">
            <img src={img("Logo_W.svg")} alt="BudgetPrintPros" className="h-7 w-auto" />
          </a>
          <p className="mt-3 max-w-xs text-xs text-slate-300 leading-relaxed">
            Custom banners, yard signs and foam core prints at budget-friendly prices. Made for businesses, events and more.
          </p>
        </Reveal>
        <Reveal as="nav" delay={100} className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-300 md:justify-center" aria-label="Footer">
          {navLinks.map((l) => (
            <a key={l.href} href={sectionHref(l.href)} className="hover:text-white">{l.name}</a>
          ))}
          <a href="mailto:hello@budgetprintpros.com" className="hover:text-white">Contact</a>
        </Reveal>
        <Reveal delay={200} className="flex gap-3" aria-label="Social links">
          {socialLinks.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.name}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20"
            >
              {socialIcons[s.name]}
            </a>
          ))}
        </Reveal>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 flex flex-col gap-2 sm:flex-row sm:justify-between text-[11px] text-slate-400">
          <p>&copy; {new Date().getFullYear()} BudgetPrintPros. All rights reserved.</p>
          <p className="flex gap-4">
            <Link to={base + "/privacy"} className="hover:text-white">Privacy Policy</Link>
            <Link to={base + "/terms"} className="hover:text-white">Terms of Use</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
